import type {
  PatchV1ScenariosIdPathParams,
  PatchV1ScenariosId200,
  PatchV1ScenariosId404,
  PatchV1ScenariosId422,
  PatchV1ScenariosIdMutationRequest,
  PatchV1ScenariosIdMutationResponse,
} from '../models'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { scenarioSchema } from './scenarioSchema'
import { scenarioUpdateSchema } from './scenarioUpdateSchema'
import { z } from 'zod'

export const patchV1ScenariosIdPathParamsSchema = z.object({
  id: z.number().nullable(),
}) as unknown as ToZod<PatchV1ScenariosIdPathParams>

export type PatchV1ScenariosIdPathParamsSchema = PatchV1ScenariosIdPathParams

/**
 * @description The updated scenario
 */
export const patchV1ScenariosId200Schema = z.lazy(() => scenarioSchema) as unknown as ToZod<PatchV1ScenariosId200>

export type PatchV1ScenariosId200Schema = PatchV1ScenariosId200

/**
 * @description Scenario not found
 */
export const patchV1ScenariosId404Schema = z.object({
  message: z.string(),
}) as unknown as ToZod<PatchV1ScenariosId404>

export type PatchV1ScenariosId404Schema = PatchV1ScenariosId404

/**
 * @description The validation error(s)
 */
export const patchV1ScenariosId422Schema = z.union([
  z
    .object({
      success: z.boolean(),
      error: z.object({
        issues: z.array(
          z.object({
            code: z.string(),
            path: z.array(z.union([z.string(), z.number()])),
            message: z.string().optional(),
          }),
        ),
        name: z.string(),
      }),
    })
    .strict(),
  z
    .object({
      success: z.boolean(),
      error: z.object({
        issues: z.array(
          z.object({
            code: z.string(),
            path: z.array(z.union([z.string(), z.number()])),
            message: z.string().optional(),
          }),
        ),
        name: z.string(),
      }),
    })
    .strict(),
]) as unknown as ToZod<PatchV1ScenariosId422>

export type PatchV1ScenariosId422Schema = PatchV1ScenariosId422

/**
 * @description The scenario updates
 */
export const patchV1ScenariosIdMutationRequestSchema = z.lazy(() => scenarioUpdateSchema) as unknown as ToZod<PatchV1ScenariosIdMutationRequest>

export type PatchV1ScenariosIdMutationRequestSchema = PatchV1ScenariosIdMutationRequest

export const patchV1ScenariosIdMutationResponseSchema = z.lazy(() => patchV1ScenariosId200Schema) as unknown as ToZod<PatchV1ScenariosIdMutationResponse>

export type PatchV1ScenariosIdMutationResponseSchema = PatchV1ScenariosIdMutationResponse